export const getTotalValue = (quantity: number, price: number) => {
	return price * quantity;
};
